import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { TextFieldPlaceholder } from "../../../Forms/TextFieldPlaceholder";
import Supplier from "../../Supplier";
import { SupplierFormProps } from "../SupplierFormProps";
import { OpenGoogleMapsIconButton } from "../../../GoogleMaps/OpenGoogleMapsIconButton";
import { useGoogleMapsModal } from "../../../GoogleMaps/useGoogleMapsModal";
import { TextFieldInput } from "../../../Forms/TextFieldInput";

export const SupplierOptionalCoordinatesForm = ({ disabledFields }: SupplierFormProps) => {
  const { control } = useFormContext<Supplier>();

  const { googleMapsModal, openGoogleMapsModal } = useGoogleMapsModal<Supplier>(
    "AltLatitude",
    "AltLongitude"
  );

  return (
    <BorderedFormGrid>
      {googleMapsModal}
      <Grid item xs={12}>
        <TextFieldInput
          name="AltLatitude"
          control={control}
          label="Latitude"
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="AltLongitude"
          control={control}
          label="Longitude"
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="AltMGLatitude"
          control={control}
          label="M&G Latitude"
          disabledFields={disabledFields}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="AltMGLongitude"
          control={control}
          label="M&G Longitude"
          disabledFields={disabledFields}
        />
      </Grid>
      {/* PLACEHOLDER */}
      <Grid item xs={12}>
        <TextFieldPlaceholder />
      </Grid>
    </BorderedFormGrid>
  );
};
